import { BehaviorService } from '@_services/Behavior.service';
import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyProfileComponent implements OnInit, OnDestroy {
  activeSubMenu: any;
  sub: Subscription;
  constructor(
    private behaviorService: BehaviorService,
    private cdf: ChangeDetectorRef,
  ) {
    this.sub = this.behaviorService.ActiveSubMenu$.subscribe((res: any) => {
      this.activeSubMenu = res;
      this.cdf.markForCheck();
    });
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  savemyprofile(): void {}
}
